// extracted by mini-css-extract-plugin
module.exports = {"horizontalRule":"Spacer_horizontalRule__nFqfp","xsmall":"Spacer_xsmall__q_BSs","small":"Spacer_small__L8_J5","medium":"Spacer_medium__TZ0eh","large":"Spacer_large__hNwaZ"};